<template>
    <div>
        <h4 class="is-size-4">Contenido</h4>
        <ol>
            <li class="is-size-5">
                <a href="/sepomex/codigos-postales/#codigos-postales">Codigos Postales</a>
            </li>
        </ol>
        <br>

        <h3 class="is-size-4" id="codigos-postales">1.- Codigos Postales</h3>
        <strong>
            Enpoint con la lista de los codigos postales, siempre regresa un array de objetos, incluso aunque sea solo un elemento
        </strong>
        <br><br>
        <p>
            <code>GET {{ host }}/api/sepomex/codigos-postales/</code>
        </p>

        <h5 class="is-size-6">Parametros opcionales para busqueda:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>municipioId</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 21)</li>
                    </ul>
                </li>
                <li>
                    <strong>activo</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato boolean (Ej. true, 1, yes, false, 0, no)</li>
                    </ul>
                </li>
            </ul>
        </div>

       
        <h5 class="is-size-6 has-text-weight-bold">Respuesta 1 de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/codigos-postales?municipioId=21</h5>
            <code>[
                {
                    "codigoPostal": "22750"
                },
                {
                    "codigoPostal": "22753"
                },
                {
                    "codigoPostal": "22755"
                },
                {
                    "codigoPostal": "22756"
                },
                {
                    "codigoPostal": "22758"
                },
                {
                    "codigoPostal": "22760"
                },
                ...
            ]</code>
        </pre>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta 2 de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/codigos-postales?municipioId=282</h5>
            <code>[
                {
                    "codigoPostal": "31000"
                },
                {
                    "codigoPostal": "31020"
                },
                {
                    "codigoPostal": "31029"
                },
                {
                    "codigoPostal": "31030"
                },
                {
                    "codigoPostal": "31034"
                },
                ...
            ]</code>
        </pre>
    </div>
</template>

<script>
export default {
    name: 'SepomexCiudades',
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style scoped>
p {
    margin-bottom: 15px;
}
</style>
